let isTerminalBusy = false;

$(function () {
  const p = $('body').attr('p');
  const isLoggedIn = $('body').attr('data-is-logged-in') == 1;
  const a = $('body').attr('a');

  if (p === 'payment_standby_mode') {
    function toggleStandaloneMode(onOffMode) {
      const terminalId = localStorage.getItem('temrinalUniqueId') || '';
      const formData = new FormData();
      formData.append('terminal_id', terminalId);
      formData.append('is_standalone_mode_on', onOffMode ? 1 : 0);
      return $.ajax({
        url: '/api/v1/private/terminal/toggle-standalone-mode',
        type: 'POST',
        data: formData,
        enctype: 'multipart/form-data',
        async: true,
        cache: false,
        processData: false,
        contentType: false,
        success: function (response) {},
        error: function (xhr, status, error) {
          if (
            xhr.responseJSON.redirect_url !== undefined &&
            xhr.responseJSON.redirect_url !== null
          ) {
            document.location.href = xhr.responseJSON.redirect_url;
          }
          console.error('Error toggling standalone mode:', error);
        },
      });
    }

    toggleStandaloneMode(1);

    // Payment status functions
    function showPaymentSuccess() {
      const $status = $('#payment-status');
      const $phoneIcon = $('#phoneIcon');
      const $spinner = $('#spinner');
      const $checkmark = $('#checkmark');
      const $xmark = $('#xmark');
      const $title = $('#statusTitle');
      const $subtitle = $('#statusSubtitle');

      // Update UI for success
      $status.addClass('success').removeClass('failed reconnecting lost');
      $phoneIcon.hide();
      $xmark.removeClass('show');
      $checkmark.addClass('show');
      $title.text('Betaling godkjent');
      $subtitle.text('Transaksjonen ble fullført');

      // Reset after 3 seconds
      setTimeout(resetToWaiting, 3000);
    }

    function showPaymentFailed() {
      const $status = $('#payment-status');
      const $phoneIcon = $('#phoneIcon');
      const $spinner = $('#spinner');
      const $checkmark = $('#checkmark');
      const $xmark = $('#xmark');
      const $title = $('#statusTitle');
      const $subtitle = $('#statusSubtitle');
      const $connectionStatus = $('#connectionStatus');
      const $connectionStatusText = $('#connectionStatusText');

      // Reset UI to waiting state
      $connectionStatus.removeClass('disconnected connecting');
      $connectionStatusText.text('Tilkoblet');
      $status
        .addClass('failed')
        .removeClass('success reconnecting lost processing');
      $spinner.removeClass('show');
      $phoneIcon.hide();
      $checkmark.removeClass('show');
      $xmark.addClass('show');
      $title.text('Betaling mislyktes');
      $subtitle.text('Vennligst prøv igjen');

      // Reset after 3 seconds
      setTimeout(resetToWaiting, 3000);
    }

    function showConnectionLost() {
      const $status = $('#payment-status');
      const $phoneIcon = $('#phoneIcon');
      const $spinner = $('#spinner');
      const $checkmark = $('#checkmark');
      const $xmark = $('#xmark');
      const $title = $('#statusTitle');
      const $subtitle = $('#statusSubtitle');
      const $connectionStatus = $('#connectionStatus');
      const $connectionStatusText = $('#connectionStatusText');

      // Update UI for connection lost
      $connectionStatus.addClass('disconnected');
      $connectionStatusText.text('Frakoblet');
      $status.addClass('failed').removeClass('success reconnecting processing');
      $spinner.removeClass('show');
      $phoneIcon.hide();
      $checkmark.removeClass('show');
      $xmark.addClass('show');
      $title.text('Tilkobling tapt');
      $subtitle.text('Kunne ikke koble til serveren');

      // Show retry button if container exists
      $('#retryContainer').show();
    }

    function showReconnecting() {
      const $status = $('#payment-status');
      const $phoneIcon = $('#phoneIcon');
      const $spinner = $('#spinner');
      const $checkmark = $('#checkmark');
      const $xmark = $('#xmark');
      const $title = $('#statusTitle');
      const $subtitle = $('#statusSubtitle');
      const $connectionStatus = $('#connectionStatus');
      const $connectionStatusText = $('#connectionStatusText');

      // Update UI for reconnecting
      $connectionStatus.addClass('connecting').removeClass('disconnected');
      $connectionStatusText.text('Prøver å koble til...');
      $status.addClass('reconnecting').removeClass('success failed processing');
      $spinner.addClass('show');
      $phoneIcon.hide();
      $checkmark.removeClass('show');
      $xmark.removeClass('show');
      $title.text('Tilkobling tapt');
      $subtitle.text('Prøver å koble til serveren igjen');

      // Remove spinner if present
      $('.icon-container .spinner').addClass('show');

      // Hide retry container
      $('#retryContainer').hide();
    }

    function resetToWaiting() {
      const $status = $('#payment-status');
      const $phoneIcon = $('#phoneIcon');
      const $spinner = $('#spinner');
      const $checkmark = $('#checkmark');
      const $xmark = $('#xmark');
      const $title = $('#statusTitle');
      const $subtitle = $('#statusSubtitle');
      const $connectionStatus = $('#connectionStatus');
      const $connectionStatusText = $('#connectionStatusText');

      // Reset UI to waiting state
      $connectionStatus.removeClass('disconnected connecting');
      $connectionStatusText.text('Tilkoblet');
      $status.removeClass('success failed processing');
      $spinner.removeClass('show');
      $checkmark.removeClass('show');
      $xmark.removeClass('show');
      $phoneIcon.show().removeClass('success failed processing');
      $title.text('Venter på betaling');
      $subtitle.text('Klar til å motta betaling');

      // Remove spinner if present
      $('.icon-container .spinner').removeClass('show');

      // Hide retry container
      $('#retryContainer').hide();
    }

    // Expose functions globally for testing
    window.showPaymentSuccess = showPaymentSuccess;
    window.showPaymentFailed = showPaymentFailed;
    window.showConnectionLost = showConnectionLost;
    window.showReconnecting = showReconnecting;
    window.resetToWaiting = resetToWaiting;

    let holdTimer;
    const holdDuration = 3000;

    $('#connectionStatus').on('mousedown touchstart', function (e) {
      e.preventDefault();

      $(this).addClass('tapped');

      holdTimer = setTimeout(() => {
        exitStandby();
        $(this).removeClass('tapped');
      }, holdDuration);
    });

    $('#connectionStatus').on(
      'mouseup mouseleave touchend touchcancel',
      function () {
        if (holdTimer) {
          clearTimeout(holdTimer);
        }
        $(this).removeClass('tapped');
      }
    );

    function exitStandby() {
      $('#exitOverlay').addClass('active');
    }

    $(document).on('submit', '#confirmExitForm', function (e) {
      e.preventDefault();
      const temrinalUniqueId = localStorage.getItem('temrinalUniqueId') || '';
      toggleStandaloneMode(0).done(() => {
        window.globalSocket.send(
          JSON.stringify({
            type: 'verifone',
            action: 'terminal_unavailable',
            temrinalUniqueId: temrinalUniqueId,
          })
        );
        document.location.href = $('#connectionStatus').attr('href');
      });
    });

    $('#exitOverlay').on('click', function (e) {
      if (e.target === this) {
        $(this).removeClass('active');
      }
    });

    setInterval(function () {
      $('.status-indicator').css('opacity', '0.5');
      setTimeout(function () {
        $('.status-indicator').css('opacity', '1');
      }, 500);
    }, 2000);

    $('.method-btn').on('click', function () {
      const btn = $(this);
      btn.css('background', '#d1d5db');
      setTimeout(() => {
        btn.css('background', '#f3f4f6');
      }, 150);
    });
  }

  if (
    ($('body').attr('is_verifone') == 1 || $('body').attr('is_pax') == 1) &&
    isLoggedIn &&
    a !== 'organizer_login'
  ) {
    passTerminalDataToWebView({
      action: $('body').attr('is_verifone') == 1 ? 'verifone' : 'pax',
      data: {
        action: 'check_state',
      },
    });
  }
});
